
import React, { Component } from 'react'
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { dispatchEventWithGeneric, Log, getModule } from '../../core';

import MultiSceneCommander from '../multiscene/MultiSceneCommander';
import getModeParams from '../multiscene/getModeParams';
import measureClear from '../multiscene/measureClear';
import selectMode from '../multiscene/selectMode';
import showPositionOnTrajectory from '../multiscene/showPositionOnTrajectory';
import createEventChangeView from '../events/changeView';

const log = Log.getLogger('MultiSceneForApp.multiscene.components.MultiSceneBase');

// ToDo:
let _viewer = null;

export function getMultiSceneCoreViewer() {
    return _viewer;
}

export default class MultiScene extends Component {

    classNames = mergeStyleSets({
        root: {
            height: '100%',
            width: '100%'
        }
    });

    constructor(props) {
        super(props);
        this._viewer = null;
    }

    clickObject(object) {
        if (this.props.onObjectInfo) {
            this.props.onObjectInfo(object.layerId, object.attributes);
        }
    }

    componentDidMount() {
        let options = getModule('multiscene').getOptions();

        if (options.license) {
            this._viewer = MultiSceneCore.Api.createViewer();
            // ToDo:
            _viewer = this._viewer;

            this._multiSceneCommander = new MultiSceneCommander({
                multiSceneViewer: this._viewer,
                onCommandExecuted: this.handleMultiSceneCommanderOnCommandExecuted
            });

            MultiSceneCore.Api.initLicense(this._viewer, options.license, () => {
                MultiSceneCore.Api.addEventListener(
                    this._viewer, 'camerachange', this.handleCameraChange
                );
                MultiSceneCore.Api.addEventListener(
                    this._viewer, 'onready', this.handleOnReady
                );
                MultiSceneCore.Api.addEventListener(
                    this._viewer, 'sceneaction', this.handleSceneAction
                );

                let showHomeScene = (this.props.showHomeScene || false);

                MultiSceneCore.Api.initProject(
                    this._viewer, 'multiSceneContainer',
                    this.props.projectUrl,
                    {
                        background: options.background,
                        camera: false,
                        debug: options.debug || false,
                        measure: false,
                        showHomeScene: showHomeScene
                    }
                );
                window.addEventListener('resize', this.handleResize);
            });
        } else {
            log.warn(`license for MultiSceneCore is not defined`);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.layers !== prevProps.layers) {
            this.setLayersVisibility(this.props.layers);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.commands.list !== this.props.commands.list) {
            if (nextProps.commands.list.length > 0) {
                this.execCommand(nextProps.commands.list[0]);
            }
        }

        if (nextProps.toolsMode !== this.props.toolsMode) {
            // ToDo: use constant from `map` module
            if (
                (this.props.toolsMode === 'MEASURE') &&
                (nextProps.toolsMode !== 'MEASURE')
            ) {
                this.measureClear();
            }
        }
    }

    componentWillUnmount() {
        if (this.props.multiSceneActions) {
            this.props.multiSceneActions.setInitialized(false);
        }
    }

    execCommand(command) {
        this._multiSceneCommander.execute(command);
    }

    getMeasureItem(measure) {
        return {
            id: measure._container.uuid,
            type: '3D',
            values: measure._measureValues,
        };
    }

    getModeParams = (modeId) => {
        return getModeParams(modeId);
    }

    getMultiSceneLayers() {
        let layers = [];
        this.props.layers.forEach(virtualLayer => {
            if (!virtualLayer.base) {
                virtualLayer.layers.forEach(layerId => {
                    layers.push({
                        id: `${virtualLayer.id}_${layerId}`,
                        visible: virtualLayer.visible
                    });
                });
            }
        });
        return layers;
    }

    handleCameraChange = (params) => {
        if (this.props.onCameraChange) {
            this.props.onCameraChange(params);
        }
        dispatchEventWithGeneric(
            createEventChangeView(
                params.cameraPosition, params.cameraRotation
            )
        );
    }

    handleMultiSceneCommanderOnCommandExecuted = (id) => {
        if (this.props.multiSceneActions) {
            this.props.multiSceneActions.removeCommand(id);
        }
    }

    handleOnReady = () => {
        if (this.props.multiSceneActions) {
            this.props.multiSceneActions.setInitialized(true);
        }

        this.setLayersVisibility(this.props.layers);
        this.selectMode(this.props.mode);
    }

    handleResize = (event) => {
        setTimeout(
            () => {
                this.updateSize();
            },
            100
        );
    }

    handleSceneAction = (event) => {
        switch (event.action) {
            case 'appselectpoint':
                // nop;
                break;
            case 'clickobjects':
                if (event.params.objects && (event.params.objects.length > 0)) {
                    this.clickObject(event.params.objects[0].object.userData.vectorObject);
                }
                break;
            case 'measureclear':
                this.processMeasureClear();
                break;
            case 'measureend':
                this.processMeasureEnd(event.params.measure);
                break;
            case 'measureupdated':
                this.processMeasureUpdated(event.params.measure);
                break;
            default:
                log.debug(`Uncaught scene action event "${event.action}"`);
                break;
        }
    }

    measureClear = () => {
        measureClear(this._viewer);
    }

    processMeasureClear = () => {
        this.props.measurementActions.clearMeasureList();
    }

    processMeasureEnd = (measure) => {
        this.props.appActions.setUiValue('activePanelName', 'measurement');
        this.props.measurementActions.setMeasureInList(this.getMeasureItem(measure));
    }

    processMeasureUpdated = (measure) => {
        this.props.appActions.setUiValue('activePanelName', 'measurement');
        this.props.measurementActions.setMeasureValues(measure._measureValues);
    }

    render() {
        return (
            <div id="multiSceneContainer" className={this.classNames.root} tabIndex="98" >
            </div>
        )
    }

    selectMode(modeId) {
        if (this._viewer) {
            selectMode(this._viewer, modeId);
        }
    }

    selectTool(toolId) {
        if (this._viewer) {
            let scene = this._viewer.getActualDimensionScene();
            if (scene) {
                scene.setActiveControl(toolId);
            }
        }
    }

    setLayerVisibility(layerId, visibility) {
        if (this._viewer) {
            let scene = this._viewer.getActualDimensionScene();
            if (scene) {
                scene.setLayerVisibility(
                    layerId,
                    visibility
                );
            }
        }
    }

    setLayersVisibility(layers) {
        let multiSceneLayers = this.getMultiSceneLayers(layers);
        multiSceneLayers.forEach(item => {
            this.setLayerVisibility(item.id, item.visible);
        })
    }

    showPositionOnTrajectory(trjName, photoName, x, y, z, yaw, pitch, options) {
        if (this.props.initialized) {
            showPositionOnTrajectory(
                this._viewer,
                trjName, photoName, x, y, z, yaw, pitch,
                options
            );
        }
    }

    updateSize(w, h) {
        if (this._viewer) {
            let domElement = document.getElementById('multiSceneContainer');
            if (domElement) {
                w = w || domElement.offsetWidth;
                h = h || domElement.offsetHeight;
                this._viewer.updateSize(w, h);
            }
        }
    }
}
